import { useState, useEffect, useCallback } from 'react';
import { getAllJobs } from '../services/cutlist-jobs';

// Fetches every cutlist job (each carrying its own `windows` line-items array)
// for cross-job analytics. Unlike useJobs(), this is a one-shot fetch, not a
// live listener, since window analytics don't need real-time updates.
export function useCutlistJobs() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(() => {
    setLoading(true);
    setError(null);
    getAllJobs()
      .then(setJobs)
      .catch(err => {
        console.error('Error fetching cutlist jobs:', err);
        setError(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { jobs, loading, error, refresh };
}

export default useCutlistJobs;
